// DetailsTable.js
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAreas } from "../../../../redux/reducer/areaReducer";
import DetailsRow from "./DetailsRow";
import EditForm from "./EditForm";
import PriceForm from "./PriceForm";
import { useTranslation } from "react-i18next";
import {
  updateProduct,
  updateProductReceived,
} from "../../../../redux/reducer/productReducer";
import GalleryImagesForm from "../../GalleryImagesForm";

const DetailsTable = ({
  details,
  onDelete,
  onUpdate,
  isEditing,
  isPricing,
  isGalleryEditing,
  setEditingOrder,
  setPricingOrder,
  setGalleryEditingOrder,
  refreshData,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // fetching Area
  const { areas, loadingAreas } = useSelector((state) => state.areas);

  useEffect(() => {
    dispatch(fetchAreas());
  }, [dispatch]);
  // State for price form and edit form
  const [priceForm, setPriceForm] = useState({
    weight: "",
  });
  const [editForm, setEditForm] = useState({
    weight: details.weight || "",
  });
  // console.log(editForm)

  const getLinkButton = (url) => {
    try {
      const hostname = new URL(url).hostname;
      const parts = hostname.split(".");
      const text = parts[1] || hostname;
      return (
        <button
          onClick={() => window.open(url, "_blank")}
          className="px-2 py-1 font-bold text-black duration-300 rounded bg-custom-yellow hover:bg-yellow-200"
        >
          {text}
        </button>
      );
    } catch {
      return "Invalid Link";
    }
  };

  const handleEdit = () => {
    setEditForm({
      weight: details.weight || "",
    });
    setEditingOrder(details.id);
    setPricingOrder(null);
  };

  const handlePrice = () => {
    setPriceForm({
      weight: details.weight || "",
    });
    setPricingOrder(details.id);
    setEditingOrder(null);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({ ...prev, [name]: value }));
  };

  const handlePriceChange = (e) => {
    const { name, value } = e.target;
    setPriceForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditSubmit = (e) => {
    e.preventDefault();
    // console.log(editForm)
    dispatch(updateProduct({ id: details.id, data: editForm }))
      .unwrap()
      .then(() => {
        if (onUpdate) onUpdate(); 
        refreshData();
      });
    setEditingOrder(null);
  };

  const handlePriceSubmit = (e) => {
    e.preventDefault();
    // console.log(priceForm)
    if (!priceForm.weight) {
      alert(t("priceRequired"));
      return;
    }

    // Add default values if they are not already set
    const finalForm = {
      ...priceForm,
    };

    // console.log("Final priceForm JSON data:", finalForm);
    // console.log(finalForm)
    dispatch(updateProductReceived({ id: details.id, data: finalForm }))
      .unwrap()
      .then(() => {
        if (refreshData) refreshData();
        if (onUpdate) onUpdate(); 
      });
    setPricingOrder(null);
  };
  const handleGalleryEdit = () => {
    setGalleryEditingOrder(details.id);
    setEditingOrder(null);
    setPricingOrder(null);
  };

  // console.log(areas)
  return (
    <>
      <DetailsRow
        details={details}
        onDelete={onDelete}
        onPrice={handlePrice}
        onEdit={handleEdit}
        onGallery={handleGalleryEdit}
        getLinkButton={getLinkButton}
        areas={areas}
      />
      {(isPricing || isEditing || isGalleryEditing) && (
        <div className="absolute inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
          {isEditing ? (
            <EditForm
              editForm={editForm}
              onChange={handleEditChange}
              onSubmit={handleEditSubmit}
              onCancel={() => setEditingOrder(null)}
            />
          ) : isPricing ? (
            <PriceForm
              priceForm={priceForm}
              onChange={handlePriceChange}
              onSubmit={handlePriceSubmit}
              onCancel={() => setPricingOrder(null)}
            />
          ) : (
            <GalleryImagesForm
              productId={details.id}
              images={details.images || []}
              refreshData={refreshData}
              onCancel={() => setGalleryEditingOrder(null)}
            />
          )}
        </div>
      )}
    </>
  );
};

export default DetailsTable;
